import { render, staticRenderFns } from "./UpdateOrgaliasModal.vue?vue&type=template&id=6f343832&scoped=true"
import script from "./UpdateOrgaliasModal.vue?vue&type=script&lang=js"
export * from "./UpdateOrgaliasModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateOrgaliasModal.vue?vue&type=style&index=0&id=6f343832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f343832",
  null
  
)

export default component.exports